import { ReactComponent as ArrowForwardIos } from '../../../../assets/icons/arrow-forward-ios.svg';

export { ArrowForwardIos };
